import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useMeasurementStore } from '@/store/measurementStore'
import {
  Colors,
  ButtonType,
  BfBadge,
  BfAccordion,
  BfButton,
  BfDescriptionList,
} from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'PedalHardware',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const measurementStore = useMeasurementStore()
const { selectedMeasurement } = storeToRefs(measurementStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfAccordion), {
    title: _unref(t)('setup.parts.pedals')
  }, {
    "header-right": _withCtx(() => [
      _createVNode(_unref(BfButton), {
        type: _unref(ButtonType).Outlined,
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
          _unref(router).push({
            name:
              _unref(router).currentRoute.value.meta.step === 2
                ? 'pedalSelection'
                : 'pedalUpdate',
          })
        ), ["stop"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('common.change')), 1)
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_unref(BfBadge), {
        color: 
          _unref(selectedMeasurement)?.pedal.active !== undefined
            ? _unref(Colors).Success
            : _unref(Colors).Danger
        
      }, null, 8, ["color"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BfDescriptionList), {
        label: _unref(t)('setup.pedal.model')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(selectedMeasurement)?.pedal.active
          ? `${_unref(selectedMeasurement)?.pedal.active.PEDAL_BRAND} ${_unref(selectedMeasurement)?.pedal.active.PEDAL_MODEL}`
          : '-'), 1)
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_unref(BfDescriptionList), {
        label: _unref(t)('setup.pedal.stack')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(selectedMeasurement)?.pedal.active
          ? `${_unref(selectedMeasurement)?.pedal.active.PEDAL_HEIGHT} ${_unref(t)('common.unit.mm')}`
          : '-'), 1)
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})